<template>
  <div v-if="true"
    class="container-top mt-4"
    :class="{ 'container-slim': lgAndUp || xlAndUp }"
  >
    <!-- Header Section -->
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div
            class="d-flex flex-column flex-sm-row justify-content-between align-items-center"
          >
            <div class="">
              <h2 class="text-head font-weight-bold h2 py-0 my-0 text-black">
                ChurchPlus Payments
              </h2>
            </div>
            <div class="">
              <div class="church-info border-radius-20 py-3 px-3">
                <img
                  src="/placeholder.svg?height=40&width=40&text=EC"
                  alt="Church Logo"
                  class="church-logo"
                />
                <div class="church-details">
                  <span class="church-name">{{ churchName }}</span>
                  <a href="#" @click.prevent="signOut" class="sign-out-link"
                    ><u>Sign out</u></a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Stats Cards Section -->
    <div class="container-fluid mt-5">
      <div class="row">
        <div class="col-12">
          <div class="stats-section">
            <div class="row">
              <!-- Total Amount Paid -->
              <div class="col-lg-4 col-md-4 col-12 mb-4">
                <div class="stats-card">
                  <div class="card-title">Total Amount paid</div>
                  <div class="card-content mt-4">
                    <div class="card-value mt-3">
                      {{ formatCurrency(totalAmountPaid) }}
                    </div>
                  </div>
                </div>
              </div>

              <!-- Pending Amount -->
              <div class="col-lg-4 col-md-4 col-12 mb-4">
                <div class="stats-card">
                  <div class="card-title">Pending Amount</div>
                  <div class="card-content mt-4">
                    <div class="card-value">
                      {{ formatCurrency(pendingAmount) }}
                    </div>
                  </div>
                </div>
              </div>

              <!-- Failed Transactions -->
              <div class="col-lg-4 col-md-4 col-12 mb-4">
                <div class="stats-card">
                  <div class="card-title">Failed</div>
                  <div class="card-content mt-4">
                    <div class="card-value">
                      {{ failedTransactions }} Transactions
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Make Payment Button -->
            <div class="row">
              <div class="col-12">
                <div class="payment-button-container">
                  <el-button
                    :color="primarycolor"
                    round
                    class="make-payment-btn"
                    @click="makePayment"
                  >
                    Make a Payment
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Charts Section -->
    <div class="container-fluid mt-5">
      <div class="row">
        <div class="col-12">
          <div class="row">
            <!-- Daily Trend Chart -->
            <div class="col-lg-6 col-12 mb-4">
              <div class="chart-container">
                <div class="fw-500 text-dak s-15">Daily Trend</div>
                <DonutChart
                  dom-id="daily-trend-chart"
                  :series-data="dailyTrendData"
                  :colour="chartColors"
                  :height="250"
                  chart-type="donut"
                  inner-size="75%"
                  center-text="Total Value"
                  center-value="72m"
                  :show-legend="true"
                  legend-position="right"
                  :show-data-labels="false"
                  @chart-click="handleChartClick"
                  @legend-click="handleLegendClick"
                  @chart-ready="onChartReady"
                />
              </div>
            </div>

            <!-- Payment Method Distribution Chart -->
            <div class="col-lg-6 col-12 mb-4">
              <div class="chart-container">
                <div class="fw-500 text-dak s-15">
                  Payment method distribution
                </div>
                <DonutChart
                  dom-id="payment-method-chart"
                  :seriesData="paymentMethodData"
                  :colour="chartColors"
                  :height="250"
                  chart-type="donut"
                  inner-size="75%"
                  center-text="Total Participants"
                  center-value="254k"
                  :show-legend="true"
                  legend-position="right"
                  :show-data-labels="false"
                  @chart-click="handleChartClick"
                  @legend-click="handleLegendClick"
                  @chart-ready="onChartReady"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid mt-4">
      <TableNoExport2
        :data="filteredDonations"
        :headers="donationHeadaer"
        :textHead="textHead"
        @update:searchText="handleSearchTextUpdate"
        :checkMultipleItem="false"
        :filterItem="false"
        @checkedrow="handleSelectionChange"
      >
        <template v-slot:name="{ item }">
          <div class="c-pointer fw-400 s-14">{{ item.name }}</div>
        </template>

        <template v-slot:date="{ item }">
          <div class="c-pointer fw-400 s-14">
            {{ item.date }}
          </div>
        </template>
        <template v-slot:amount="{ item }">
          <div class="c-pointer fw-400 s-14">
            N{{ item.amount.toLocaleString() || '' }}
          </div>
        </template>
        <template v-slot:channel="{ item }">
          <div class="c-pointer fw-400 s-14">
            {{ item.channel }}
          </div>
        </template>
        <template v-slot:status="{ item }">
          <div class="c-pointer fw-400 s-14">
            {{ item.status }}
          </div>
        </template>
        <template v-slot:action="{ item }">
          <el-dropdown trigger="click">
            <el-icon><MoreFilled /></el-icon>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item>
                  <div
                    class="text-color"
                    @click="deleteDonation(item.id, index)"
                  >
                    Delete
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </template>
      </TableNoExport2>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, inject } from "vue";
import PublicDonorInfo from "./PublicDonorInfo.vue";

import { useRouter } from "vue-router";
import DonutChart from "@/components/charts/DonationDonutChart.vue";
import TableNoExport2 from "../../components/table/TableNoExport2.vue";
import deviceBreakpoint from "../../mixins/deviceBreakpoint";

// Router setup
const router = useRouter();
const { lgAndUp, xlAndUp, mdAndUp } = deviceBreakpoint();
const primarycolor = inject("primarycolor");
const textHead = ref("All Donations");

// Reactive data
const churchName = ref("Ebenezer Church");
const totalAmountPaid = ref(33000000);
const pendingAmount = ref(2000000);
const failedTransactions = ref(7);
const showControls = ref(false);
const donationHeadaer = ref([
  { name: "NAME", value: "name" },
  { name: "DATE", value: "date" },
  { name: "AMOUNT", value: "amount" },
  { name: "CHANNEL", value: "channel" },
  { name: "STATUS", value: "status" },
]);
const searchText = ref("");
// Chart colors
const chartColors = ref([
  "#14B8A6", // teal
  "#3B82F6", // vivid blue
  "#6366F1", // cyan
  "#E697FF", // mint
  "#63ABFD", // sky blue
  "#CACACA", // emerald
]);

// Chart data - formatted for Highcharts
const dailyTrendData = ref([
  { name: "Mobile Payments", y: 25 },
  { name: "Bank Transfer", y: 20 },
  { name: "Card Payments", y: 15 },
  { name: "Cash Donations", y: 15 },
  { name: "Online Banking", y: 15 },
  { name: "Others", y: 10 },
]);

const paymentMethodData = ref([
  { name: "Paystack", y: 30 },
  { name: "Flutterwave", y: 25 },
  { name: "Bank Transfer", y: 20 },
  { name: "Cash", y: 10 },
  { name: "Stripe", y: 10 },
  { name: "Others", y: 5 },
]);
const donations = ref([
  {
    name: "Matthew Stephen",
    date: "May 10, 2024",
    amount: 2000,
    channel: "Stripe",
    status: "Success",
  },
  {
    name: "Matthew Stephen",
    date: "May 10, 2024",
    amount: 2000,
    channel: "Stripe",
    status: "Success",
  },
  {
    name: "Matthew Stephen",
    date: "May 10, 2024",
    amount: 2000,
    channel: "Stripe",
    status: "Success",
  },
  {
    name: "Matthew Stephen",
    date: "May 10, 2024",
    amount: 2000,
    channel: "Stripe",
    status: "Success",
  },
  {
    name: "Matthew Stephen",
    date: "May 10, 2024",
    amount: 2000,
    channel: "Stripe",
    status: "Success",
  },
  {
    name: "Matthew Stephen",
    date: "May 10, 2024",
    amount: 2000,
    channel: "Stripe",
    status: "Success",
  },
]);
const filteredDonations = computed(() => {
  if (!searchText.value) return donations.value;
  return donations.value.filter((d) =>
    Object.values(d).some((val) =>
      String(val).toLowerCase().includes(searchText.value.toLowerCase())
    )
  );
});
const handleSearchTextUpdate = (newValue) => {
  searchText.value = newValue;
};
// Methods
const formatCurrency = (amount) => {
  return `NGN${amount.toLocaleString()}`;
};
const deleteDonation = () => {
  donations.value = donations.value.splice(index, 1);
};

const makePayment = () => {
  console.log("Make payment clicked");
  // Handle make payment action
};

const signOut = () => {
  console.log("Sign out clicked");
  router.push("/login");
};
const handleSelectionChange = (selectedRows) => {
  console.log("Selected rows:", selectedRows);
};

const handleChartClick = (data) => {
  console.log("Chart clicked:", data.point.name, data.point.y);
  // Handle chart segment click
};

const handleLegendClick = (data) => {
  console.log("Legend clicked:", data.point.name);
  // Handle legend item click
};

const onChartReady = (chart) => {
  console.log("Chart ready:", chart);
  // Handle chart ready event
};

// Demo control methods
const refreshChartData = () => {
  // Generate random data for demo
  const generateRandomData = (labels) => {
    return labels.map((label) => ({
      name: label,
      y: Math.floor(Math.random() * 30) + 5,
    }));
  };

  dailyTrendData.value = generateRandomData([
    "Mobile Payments",
    "Bank Transfer",
    "Card Payments",
    "Cash Donations",
    "Online Banking",
    "Others",
  ]);

  paymentMethodData.value = generateRandomData([
    "Paystack",
    "Flutterwave",
    "Bank Transfer",
    "Cash",
    "Stripe",
    "Others",
  ]);
};

const toggleControls = () => {
  showControls.value = !showControls.value;
};

const updateCenterValues = () => {
  // This would trigger a re-render with new center values
  console.log("Center values updated");
};

const switchChartType = () => {
  // This would switch between pie and donut charts
  console.log("Chart type switched");
};

// Lifecycle
onMounted(() => {
  // Enable controls for demo
  showControls.value = true;
});
</script>

<style scoped>
.dashboard-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.church-info {
  background-color: #f0f0f0;
  display: flex;
  /* justify-content: flex-end; */
  align-items: center;
  gap: 1rem;
}

.church-logo {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  background: #1f2937;
}

.church-details {
  display: flex;
  flex-direction: column;
  /* align-items: flex-end; */
}

.church-name {
  font-weight: 600;
  color: #1f2937;
  font-size: 0.9rem;
}

.sign-out-link {
  color: #020f1e;
  text-decoration: none;
  font-size: 0.8rem;
}

.sign-out-link:hover {
  color: #374151;
  text-decoration: underline;
}

.stats-section {
  margin-bottom: 2rem;
}

.stats-card {
  background: #e3fffd;
  border: 1px solid #a0bceb;
  border-radius: 8px;
  /* padding: 2rem 1.5rem; */
  height: 140px;
  transition: all 0.2s ease;
}

.stats-card:hover {
  transform: translateY(-2px);
  background: #e3fffd;
  border: 1px solid #a0bceb;
  /* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); */
}

.card-content {
  text-align: center;
  width: 100%;
}

.card-title {
  margin-top: 0.8rem;
  margin-left: 1rem;
  font-size: 14px;
  font-weight: 600;
  color: #111111;
  line-height: 1.2;
}

.card-value {
  font-size: 1.5rem;
  font-weight: 500;
  color: #111111;
  line-height: 1.2;
}

.payment-button-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
}

.make-payment-btn {
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(37, 99, 235, 0.2);
}

.make-payment-btn:hover {
  background: #1d4ed8;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(37, 99, 235, 0.3);
}

.chart-container {
  height: 100%;
}

.controls-section {
  margin-bottom: 2rem;
}

.controls-section .card {
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.controls-section .card-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: #1f2937;
}

/* Responsive Design */
@media (max-width: 768px) {
  .dashboard-title {
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }

  .church-info {
    justify-content: flex-start;
  }

  .church-details {
    align-items: flex-start;
  }

  .stats-card {
    padding: 1.5rem 1rem;
    height: 120px;
    margin-bottom: 1rem;
  }

  .card-value {
    font-size: 1.25rem;
  }

  .payment-button-container {
    justify-content: center;
    margin-top: 1.5rem;
  }

  .make-payment-btn {
    width: 100%;
    max-width: 300px;
  }

  .chart-container {
    height: 100%;
  }
}

@media (max-width: 576px) {
  .dashboard-title {
    font-size: 1.25rem;
  }

  .stats-card {
    height: 100px;
    padding: 1rem;
  }

  .card-value {
    font-size: 1.125rem;
  }

  .card-title {
    font-size: 0.8rem;
  }

  .chart-container {
    height: 300px;
  }
}

/* Bootstrap utilities */
.container-fluid {
  padding-left: 1rem;
  padding-right: 1rem;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.text-center {
  text-align: center !important;
}

.d-flex {
  display: flex !important;
}

.align-items-center {
  align-items: center !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}
</style>
